const formatNumber = (number: number, fractionDigits: number = 2) => {
    // Intl.NumberFormat does not handle small numbers well. This handles
    // edge cases for small decimal numbers
    if (Math.abs(number) < 0.1) {
        return Number(number).toFixed(fractionDigits);
    }

    return Intl.NumberFormat('en', {
        notation: 'compact',
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    }).format(number);
};

export { formatNumber };
